import * as React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const FilesZipIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg role="presentation" focusable="false" viewBox="0 0 20 20" className={classes.svg}>
      <defs>
        <linearGradient id="FilesZipIconLinearGradient" x1="1" y1="5" x2="1" y2="17" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0.01" />
          <stop offset="0.999" stopColor="#FFD75E" stopOpacity="0.3" />
        </linearGradient>
      </defs>
      <path
        d="M10 5L8.586 3.586C8.21101 3.2109 7.70239 3.00011 7.172 3H2C1.44772 3 1 3.44772 1 4V16C1 16.5523 1.44772 17 2 17H18C18.5523 17 19 16.5523 19 16V6C19 5.44772 18.5523 5 18 5H10Z"
        fill="#FFB900"
      />
      <path
        d="M10 5L8.586 6.414C8.21101 6.7891 7.70239 6.99989 7.172 7H1V16C1 16.5523 1.44772 17 2 17H18C18.5523 17 19 16.5523 19 16V6C19 5.44772 18.5523 5 18 5H10Z"
        fill="#FFD75E"
      />
      <path
        d="M10 5L8.586 6.414C8.21101 6.7891 7.70239 6.99989 7.172 7H1V16C1 16.5523 1.44772 17 2 17H18C18.5523 17 19 16.5523 19 16V6C19 5.44772 18.5523 5 18 5H10Z"
        fill="url(#FilesZipIconLinearGradient)"
      />
      <path
        d="M1.99986 16.4999C1.62686 16.4999 1.28986 16.3579 1.02686 16.1329C1.08759 16.6252 1.50388 16.9961 1.99986 16.9999H17.9999C18.5049 16.9999 18.9049 16.6199 18.9729 16.1329C18.7109 16.3589 18.3729 16.4999 17.9999 16.4999H1.99986Z"
        fill="#E67628"
      />
      <path
        opacity="0.4"
        d="M8.836 6.914L10.75 5H10L8.586 6.414C8.21101 6.7891 7.70239 6.99989 7.172 7H1V7.5H7.422C7.95239 7.49989 8.46101 7.2891 8.836 6.914Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 10H8.75C8.88807 10 9 10.1119 9 10.25V13.75C9 13.8881 8.88807 14 8.75 14H2.25C2.112 14 2 13.888 2 13.75V13H3V11H2V10.25C2 10.1119 2.11193 10 2.25 10ZM6 13H8V11H6V13ZM10.75 13H10.25C10.1119 13 10 12.8881 10 12.75V11.25C10 11.1119 10.1119 11 10.25 11H10.75C10.8881 11 11 11.1119 11 11.25V12.75C11 12.8881 10.8881 13 10.75 13ZM12.25 13H12.75C12.8881 13 13 12.8881 13 12.75V11.25C13 11.1119 12.8881 11 12.75 11H12.25C12.1119 11 12 11.1119 12 11.25V12.75C12 12.8881 12.1119 13 12.25 13ZM14.75 13H14.25C14.1119 13 14 12.8881 14 12.75V11.25C14 11.1119 14.1119 11 14.25 11H14.75C14.8881 11 15 11.1119 15 11.25V12.75C15 12.8881 14.8881 13 14.75 13ZM16.25 13H16.75C16.8881 13 17 12.8881 17 12.75V11.25C17 11.1119 16.8881 11 16.75 11H16.25C16.1119 11 16 11.1119 16 11.25V12.75C16 12.8881 16.1119 13 16.25 13ZM18.75 13H18.25C18.1119 13 18 12.8881 18 12.75V11.25C18 11.1119 18.1119 11 18.25 11H18.75C18.8881 11 19 11.1119 19 11.25V12.75C19 12.8881 18.8881 13 18.75 13ZM1 13H1.75C1.88807 13 2 12.8881 2 12.75V11.25C2 11.1119 1.88807 11 1.75 11H1V13Z"
        fill="#BF5712"
      />
    </svg>
  ),
  displayName: 'FilesZipIcon',
});
